<template>
  <div class="handlebar-selection">
    <div class="handlebar-selection__filters">
      <HandlebarFilters />
    </div>
    <div class="handlebar-selection__content">
      <h1>{{ t('setup.handlebar.selection') }}</h1>

      <HandlebarSelection @select="select" />

      <div class="handlebar-selection__buttons">
        <BfButton
          :type="ButtonType.Outlined"
          @click="cancel"
        >
          {{ t('common.cancel') }}
        </BfButton>
        <BfButton
          :state="selected ? ButtonState.Enabled : ButtonState.Disabled"
          @click="install"
        >
          {{ t('common.install') }}
        </BfButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useHandlebarStore } from '@/store/handlebarStore'
import { useMeasurementStore } from '@/store/measurementStore'
import { useBikeStore } from '@/store/bikeStore'
import { useRouter } from 'vue-router'
import HandlebarFilters from '@/components/setup/handlebar/HandlebarFilters.vue'
import HandlebarSelection from '@/components/setup/handlebar/HandlebarSelection.vue'
import { ButtonState, ButtonType, BfButton } from '@finetic/bikefitting-ui'
import { useI18n } from 'vue-i18n'
import { BikeHoodsType } from '@/types/bike'
import { PreviewImage } from '@/types/preview'

const { t } = useI18n()
const router = useRouter()
const handlebarStore = useHandlebarStore()
const measurementStore = useMeasurementStore()
const bikeStore = useBikeStore()
const selected = ref()

handlebarStore.reset()

const { bikePreview } = storeToRefs(bikeStore)

const select = (pedal: any) => {
  selected.value = pedal
}

const cancel = () => {
  router.push({
    name: router.currentRoute.value.meta.update ? 'analysis' : 'setup',
  })
}

const install = () => {
  if (measurementStore.selectedMeasurement) {
    measurementStore.selectedMeasurement.handlebar.active = selected.value

    switch (bikeStore.bikeHoodsType) {
      case BikeHoodsType.DROPBAR:
        bikePreview.value = PreviewImage.DROPBAR_BIKE
        break

      case BikeHoodsType.FLATBAR:
        bikePreview.value = PreviewImage.FLATBAR_BIKE
        break

      case BikeHoodsType.TRIBAR:
        bikePreview.value = PreviewImage.TRIBAR_BIKE
        break

      default:
        bikePreview.value = PreviewImage.DROPBAR_BIKE
        break
    }
  }

  router.push({
    name: router.currentRoute.value.meta.update ? 'analysis' : 'setup',
  })
}
</script>

<style lang="scss">
.handlebar-selection {
  display: grid;
  grid-template-columns: 40% 60%;
  height: 100%;

  &__filters {
    background-color: #f5f5f5;
  }

  &__content {
    background-color: #fbfbfb;
    padding: 2.4rem;
  }

  &__buttons {
    margin-top: 3.2rem;
    display: flex;
    justify-content: flex-end;
    gap: 0.8rem;
  }
}
</style>
